<template>
    <a-list
        class="container"
        itemLayout="horizontal"
        :grid="{ gutter: 10, xs: 1, sm: 2, md: 3, lg: 3, xl: 3, xxl: 3 }"
    >   
        <a-spin size="large" />
    </a-list>
</template>

<script>
export default {
    
}
</script>